import './Platforms.css';

const PLATFORMS = [
  {
    id: '1',
    name: 'TakeTitle',
    icon: '🏛️',
    connected: 'Jan 10, 2026',
    lastActivity: '5 minutes ago',
    messageCount: 47,
    permissions: ['Receive notifications', 'Investment confirmations', 'Governance proposals'],
  },
  {
    id: '2',
    name: 'TrueResolve',
    icon: '⚖️',
    connected: 'Jan 12, 2026',
    lastActivity: '2 days ago',
    messageCount: 12,
    permissions: ['Receive notifications', 'Case updates'],
  },
  {
    id: '3',
    name: 'eStream Console',
    icon: '⬡',
    connected: 'Jan 8, 2026',
    lastActivity: 'Today',
    messageCount: 8,
    permissions: ['Receive notifications', 'Network alerts'],
  },
];

export default function Platforms() {
  return (
    <div className="platforms-page animate-in">
      {/* Header Actions */}
      <div className="page-actions">
        <button className="btn btn-primary">+ Connect New</button>
      </div>

      {/* Connected Platforms */}
      <section className="platforms-section">
        <h2 className="section-title">Connected Platforms</h2>
        <div className="platforms-grid">
          {PLATFORMS.map((platform) => (
            <div key={platform.id} className="platform-card card">
              <div className="platform-header">
                <span className="platform-icon">{platform.icon}</span>
                <span className="platform-name">{platform.name}</span>
                <span className="status-indicator status-active">
                  <span className="status-dot active"></span>
                  Connected
                </span>
              </div>
              
              <div className="platform-meta">
                <div className="meta-row">
                  <span className="meta-label">Connected:</span>
                  <span className="meta-value">{platform.connected}</span>
                </div>
                <div className="meta-row">
                  <span className="meta-label">Last activity:</span>
                  <span className="meta-value">{platform.lastActivity}</span>
                </div>
                <div className="meta-row">
                  <span className="meta-label">Messages received:</span>
                  <span className="meta-value">{platform.messageCount}</span>
                </div>
              </div>

              <div className="platform-permissions">
                <span className="permissions-label">Permissions:</span>
                <ul className="permissions-list">
                  {platform.permissions.map((perm, i) => (
                    <li key={i}>✓ {perm}</li>
                  ))}
                </ul>
              </div>

              <div className="platform-actions">
                <button className="btn btn-secondary">View Messages</button>
                <button className="btn btn-secondary">Manage</button>
                <button className="btn btn-danger">Disconnect</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
